import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { concat } from '@ember/helper'
import { t } from 'ember-intl'
import ContentfulEdit from 'teacher-ui-client/components/contentful/edit'
import UiButton from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { pdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import PopoverStandardDropdown from '@blakeelearning/popovers/components/popover/dropdowns/standard'
import type { LessonResource } from 'teacher-ui-client/components/tiles/lesson/resource/type'

interface Signature {
  Args: {
    lessonResources: LessonResource[]
  }
}

export const LessonResourcesTile: TOC<Signature> = <template>
  {{#if @lessonResources}}
    <span>
      <PopoverStandardDropdown as |dropdown|>
        <UiButton data-test-dropdown-trigger @appearance={{ButtonAppearance.muted}} {{dropdown.makeTrigger}}>
          <PhosphorIcon @icon="phosphor-file-text-fill" class="mr-2 h-3.5 w-3.5" />
          {{t "components.tiles.lessonPreviewEntry.resources"}}
          <PhosphorIcon @icon="phosphor-caret-down-bold" class="h-3.5 w-3.5" />
        </UiButton>
        <dropdown.content>
          <ul
            data-test-dropdown-content
            class="border-dusty-black-100 min-w-40 rounded-md border bg-white py-2 shadow-xl"
          >
            {{#each @lessonResources as |resource|}}
              <li class="hover:bg-dusty-black-50 focus:bg-dusty-black-50 relative whitespace-nowrap">
                <ContentfulEdit class="absolute top-1/2 right-0 mx-2 -translate-y-1/2" @entryId={{resource.id}} />
                <a
                  href={{resource.fileUrl}}
                  target="_blank"
                  rel="noopener noreferrer"
                  class="block cursor-pointer px-6 py-1 text-black hover:text-black focus:text-black"
                  {{pdfDownloadEvent
                    category="Lesson Preview PDF"
                    label=resource.title
                    resourceType=resource.resourceType
                  }}
                >
                  {{t
                    (concat "components.tiles.lessonPreviewEntry.resourceTypes." resource.resourceType)
                    default="components.tiles.lessonPreviewEntry.resourceTypes.default"
                  }}
                </a>
              </li>
            {{/each}}
          </ul>
        </dropdown.content>
      </PopoverStandardDropdown>
    </span>
  {{/if}}
</template>

export default LessonResourcesTile
